import { useModalContentToggler } from '@components'

import { Button, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useSegment } from '../../../../hooks'
import { useMultiplePayableSubjects, usePaymentModal } from '../../../paymentReconciliationModal/contexts'

export const MultipleSubjectsModalFooter = (): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { selectedSubjectsIds } = useMultiplePayableSubjects()
  const { modalId } = usePaymentModal()
  const { setActiveState, prevState, activeStateModalData } = useModalContentToggler()
  useModal(modalId, {
    onClose: () => {
      track('xxx - expenses - Multiple bill selection modal closed')
    },
  })

  const handleContinueToPaymentButtonClick = useCallback(() => {
    if (activeStateModalData?.backwardsNavigationStateId) {
      setActiveState(activeStateModalData?.backwardsNavigationStateId)
    } else {
      setActiveState(prevState)
    }

    track('xxx - expenses - Prepayment modal - continue payment clicked', {
      selectedBillsCount: selectedSubjectsIds?.length || 0,
    })
  }, [selectedSubjectsIds?.length, setActiveState, track, prevState, activeStateModalData?.backwardsNavigationStateId])

  return (
    <Button onClick={handleContinueToPaymentButtonClick}>
      {t('bill.payment_reconcile.button.continue_to_payment')}
    </Button>
  )
}
